// src/components/26.js
import React from 'react';

const Componente26 = () => {
  return (
    <div className="component-container">
      <h2>Número de Propósito: 26</h2>
      <p>
        Para una persona nacida el día 26, el número de propósito asociado sería 26.
      </p>
      <p>
        En numerología, el número 26 está vinculado a la responsabilidad, la generosidad y el servicio a los demás. Las personas nacidas en este día suelen ser muy conscientes de su entorno y están motivadas para ayudar a los demás. Su propósito puede incluir:
      </p>
      <ul>
        <li><strong>Asumir Responsabilidades:</strong> Estas personas están destinadas a asumir responsabilidades tanto en su vida personal como profesional.</li>
        <li><strong>Servir a la Comunidad:</strong> Su propósito puede incluir involucrarse activamente en su comunidad y contribuir al bienestar de los demás.</li>
        <li><strong>Fomentar la Generosidad:</strong> Tienen un fuerte deseo de compartir sus recursos y talentos con quienes los rodean.</li>
        <li><strong>Inspirar a Otros a Servir:</strong> Su dedicación al servicio puede motivar a otros a involucrarse y hacer una diferencia.</li>
      </ul>

      <h3>Características del Día de Nacimiento: 26</h3>
      <ul>
        <li><strong>Responsables:</strong> Tienen una fuerte ética de trabajo y se comprometen a cumplir sus deberes.</li>
        <li><strong>Generosos:</strong> Su deseo de ayudar a los demás a menudo se traduce en acciones concretas y altruistas.</li>
        <li><strong>Empáticos:</strong> Su capacidad para comprender las necesidades de los demás les permite ofrecer un apoyo valioso.</li>
      </ul>

      <h4>Resumen</h4>
      <p>
        Las personas nacidas el día 26 son responsables y generosas, con un propósito centrado en el servicio a los demás y la asunción de responsabilidades. Su dedicación a ayudar a otros y su empatía les permiten hacer una diferencia significativa en su comunidad y en la vida de quienes los rodean.
      </p>
    </div>
  );
};

export default Componente26;
